import { render } from "./QuickTable.vue?vue&type=template&id=1af4e3bd&scoped=true"
import script from "./QuickTable.vue?vue&type=script&lang=js"
export * from "./QuickTable.vue?vue&type=script&lang=js"

import "./QuickTable.vue?vue&type=style&index=0&id=1af4e3bd&lang=scss&scoped=true"

import exportComponent from "/Users/shuaqq/Desktop/quickadmin/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af4e3bd"]])

export default __exports__